import {Component, ViewChild, AfterViewInit, ViewContainerRef, ComponentFactory, ComponentRef, ComponentFactoryResolver, EventEmitter, Input, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

import {MensajeService} from '@mensaje/Mensaje.Service';
import { RespuestaEstatusEnum } from '@enumeraciones/Enumeraciones.enum';
import { Modelogoogle } from '@modelo/proceso/modelogoogle.model';
import { AlertaEnum } from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';

@Component(
    {
        selector: 'encuestadetalle',
        templateUrl: './general_detalle.component.html',
        styleUrls: ['./general.component.scss']
    })

export class EncuestaDetalleComponent implements AfterViewInit {
  consulta!: boolean;

  @Input() accion!: {accionid: number, accion: string};
  @Input() entidad!: Modelogoogle;
  @Output() output = new EventEmitter();

  listaTipoEncuesta: any[] = [];
  SelCiclo:any[] = [];

  tipoEncuesta:any;
  datatable: any[] = [];
  entidadGuardar:Modelogoogle = new Modelogoogle();
  selectedIndex: number | null = null;
  cambio:boolean = false;


    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver) {
    }

    ngAfterViewInit() {
      this.getTipoEncuesta();
      this.GetCiclo();
      this.verforms();
    }

    verresultados(){
      this.appService.Post("encuestagoogle/encuesta/verresultado",{"formularioid": this.entidad.id}).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          console.log(res.data);
        }
      })
    }

    selectPanel(index: number, select:Modelogoogle): void {
      this.selectedIndex = this.selectedIndex === index ? null : index;
      this.entidadGuardar = select;
    }

    getTipoEncuesta(){
      this.appService.Get("encuestagoogle/encuesta/tipoencuesta").then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.listaTipoEncuesta = res.data;
        }
      })
    }

    verforms(){
      this.appService.Get("encuestagoogle/encuesta/verforms").then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.datatable = res.data;
        }
      })
    }

    GetCiclo(){
      this.appService.Get("catalogo/ciclo").then(res => {
        if (res.status == RespuestaEstatusEnum.Success) {
            this.SelCiclo = res.data;
        }
    });
    }

    Guardar(){
      let respuesta = this.validar();
      switch(this.tipoEncuesta){
        case 1:
          if(respuesta == true){
            this.appService.Post("encuestagoogle/encuesta/formulariogoogle",this.entidad).then(res=>{
              if(res.status == RespuestaEstatusEnum.Success){
                console.log(res.data);
                let url = "https://docs.google.com/forms/d/"+res.data.formid+"/edit";
                window.open(url, '_blank');
                this.cambio = true;
                this.Salir();
              }
            })
          }else{
            this.mensajeService.Alerta(AlertaEnum.Warning, this.validar());
          }

          break;
        case 2:
          this.appService.Post("encuestagoogle/encuesta",{'entidad':this.entidadGuardar}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
              this.mensajeService.Alerta(AlertaEnum.Success, res.message);
              this.cambio = true;
              this.Salir();
            }
          })
          break;
        case 3:
          if(respuesta == true){
            this.appService.Post("encuestagoogle/encuesta/copiarforms",{"entidad":this.entidad, "copia": this.entidadGuardar}).then(res=>{
              if(res.status == RespuestaEstatusEnum.Success){
                this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                let url = "https://docs.google.com/forms/d/"+res.data.id+"/edit";
                window.open(url, '_blank');
                this.cambio = true;
                this.Salir();
              }
            })
          }else{
            this.mensajeService.Alerta(AlertaEnum.Warning, this.validar());
          }
          break;
      }
    }

    cargardatos(){
        this.entidadGuardar = new Modelogoogle();
        this.selectedIndex = null;
        this.entidad = new Modelogoogle();
    }

    validar(): any {
      if(!this.entidad.name && this.tipoEncuesta == 1){
        return "se requiere un nombre para el formulario"
      }
      // if(!this.entidad.descripcion){
      //   return "se requiere una descripcion para el formulario"
      // }
      if(!this.entidad.titulodeldocumento){
        return "se requiere un nombre para el documento a generar"
      }

      if(!this.entidad.cicloid){
        return "Se requiere un ciclo para generar el documento"
      }

      if(!this.entidadGuardar.id && this.tipoEncuesta == 3){
        return "Se requiere seleccionar una encuesta a la cual copiar"
      }
      return true;
    }


    Salir(){
      this.output.next(this.cambio);
    }

}
